module.exports = __webpack_public_path__ + "static/img/banner.76b0653.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom_develop/banner.png
// module id = VD0x
// module chunks = 1